import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { onboardingActions as actions, notificationActions } from '../actions'
import { onboardingService } from '../services';

// add personal details
function* handleAddPersonalDetailsRequest() {
    const action = yield take(actions.addPersonalDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.addPersonalDetails, dataParams);
        if (res.isError) {
            yield put(actions.addPersonalDetailsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addPersonalDetailsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addPersonalDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// add family details
function* handleAddFamilyDetailsRequest() {
    const action = yield take(actions.addFamilyDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.addFamilyDetails, dataParams);
        if (res.isError) {
            yield put(actions.addFamilyDetailsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addFamilyDetailsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addFamilyDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// add Education details
function* handleAddEducationDetailsRequest() {
    const action = yield take(actions.addEducationDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.addEducationDetails, dataParams);
        if (res.isError) {
            yield put(actions.addEducationDetailsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addEducationDetailsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addEducationDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// add bank details
function* handleAddBankDetailsRequest() {
    const action = yield take(actions.addBankDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.addBankDetails, dataParams);
        if (res.isError) {
            yield put(actions.addBankDetailsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addBankDetailsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addBankDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// add social details
function* handleAddSocialDetailsRequest() {
    const action = yield take(actions.addSocialDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.addSocialDetails, dataParams);
        if (res.isError) {
            yield put(actions.addSocialDetailsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addSocialDetailsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addSocialDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// add WorkExperience details
function* handleAddWorkExperienceDetailsRequest() {
    const action = yield take(actions.addWorkExperienceDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.addWorkExperienceDetails, dataParams);
        if (res.isError) {
            yield put(actions.addWorkExperienceDetailsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addWorkExperienceDetailsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addWorkExperienceDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// add reference details
function* handleAddReferenceDetailsRequest() {
    const action = yield take(actions.addReferenceDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.addReferenceDetails, dataParams);
        if (res.isError) {
            yield put(actions.addReferenceDetailsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addReferenceDetailsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addReferenceDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// add document details
function* handleAddDocumentDetailsRequest() {
    const action = yield take(actions.addDocumentDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.addDocumentDetails, dataParams);
        if (res.isError) {
            yield put(actions.addDocumentDetailsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addDocumentDetailsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addDocumentDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// get onboarding details
function* handleGetAllOnboardingDetailsRequest() {
    const action = yield take(actions.getAllOnboardingDetailsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.getAllOnboardingSteps, dataParams);
        if (res.isError) {
            yield put(actions.getAllOnboardingDetailsError(res));
            // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.getAllOnboardingDetailsSuccess(res));
            // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.getAllOnboardingDetailsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// get employee documents
function* handleGetAllEmpDocsRequest() {
    const action = yield take(actions.getAllEmpDocsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(onboardingService.getAllEmpDocs, dataParams);
        if (res.isError) {
            yield put(actions.getAllEmpDocsError(res));
            // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.getAllEmpDocsSuccess(res));
            // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.message, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.getAllEmpDocsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// -----------Watchers-------------
// personal details
function* handleAddPersonalDetailsWatcher() {
    yield takeEvery(
        actions.addPersonalDetailsRequest,
        handleAddPersonalDetailsRequest,
    );
};

// family details
function* handleAddFamilyDetailsWatcher() {
    yield takeEvery(
        actions.addFamilyDetailsRequest,
        handleAddFamilyDetailsRequest,
    );
};

// Education details
function* handleAddEducationDetailsWatcher() {
    yield takeEvery(
        actions.addEducationDetailsRequest,
        handleAddEducationDetailsRequest,
    );
};

// bank details
function* handleAddBankDetailsWatcher() {
    yield takeEvery(
        actions.addBankDetailsRequest,
        handleAddBankDetailsRequest,
    );
};

// socail details
function* handleAddSocialDetailsWatcher() {
    yield takeEvery(
        actions.addSocialDetailsRequest,
        handleAddSocialDetailsRequest,
    );
};

// Work Experience details
function* handleAddWorkExperienceDetailsWatcher() {
    yield takeEvery(
        actions.addWorkExperienceDetailsRequest,
        handleAddWorkExperienceDetailsRequest,
    );
};
// reference details
function* handleAddReferenceDetailsWatcher() {
    yield takeEvery(
        actions.addReferenceDetailsRequest,
        handleAddReferenceDetailsRequest,
    );
};

// document details
function* handleAddDocumentDetailsWatcher() {
    yield takeEvery(
        actions.addDocumentDetailsRequest,
        handleAddDocumentDetailsRequest,
    );
};

// onboarding steps details
function* handleGetAllOnboardingDetailsWatcher() {
    yield takeEvery(
        actions.getAllOnboardingDetailsRequest,
        handleGetAllOnboardingDetailsRequest,
    );
};

// employee docs details
function* handleGetAllEmpDocsWatcher() {
    yield takeEvery(
        actions.getAllEmpDocsRequest,
        handleGetAllEmpDocsRequest,
    );
};

function* rootOnboardingSaga() {
    yield all([
        // personal details
        handleAddPersonalDetailsRequest(),
        handleAddPersonalDetailsWatcher(),

        // family details
        handleAddFamilyDetailsRequest(),
        handleAddFamilyDetailsWatcher(),

        // family details
        handleAddEducationDetailsRequest(),
        handleAddEducationDetailsWatcher(),

        // bank details
        handleAddBankDetailsRequest(),
        handleAddBankDetailsWatcher(),

        // social details
        handleAddSocialDetailsRequest(),
        handleAddSocialDetailsWatcher(),

        // Work Experience details
        handleAddWorkExperienceDetailsRequest(),
        handleAddWorkExperienceDetailsWatcher(),

        // reference details
        handleAddReferenceDetailsRequest(),
        handleAddReferenceDetailsWatcher(),

        // document details
        handleAddDocumentDetailsRequest(),
        handleAddDocumentDetailsWatcher(),

        // onboarding steps details
        handleGetAllOnboardingDetailsRequest(),
        handleGetAllOnboardingDetailsWatcher(),

        // employee documents details
        handleGetAllEmpDocsRequest(),
        handleGetAllEmpDocsWatcher(),
    ]);
}

export default rootOnboardingSaga;
